import { OrderTypes } from '../../../constants/orderTypes';

export const NEEDS_SORTED_RESERVATION = [OrderTypes.FLIGHT, OrderTypes.BUS];
